import { DateFormat, formatDate } from "common";
import React from "react";
import { Email } from "types";

interface EmailItemProps {
    email: Email;
    onSelectEmail: (email: Email) => void;
    isSelected: boolean;
}

export const EmailListItem = ({ email, onSelectEmail, isSelected }: EmailItemProps) => {
    return (
        <div
            key={email.id}
            className={`ui-email-list-item cursor-pointer p-4 hover:bg-blue-lighter ${
                isSelected ? "bg-blue-lighter" : ""
            }`}
            onClick={() => onSelectEmail(email)}
        >
            <p className="no-translate font-bold">{email.to[0].name ?? "<No Name>"}</p>
            <p className="no-translate">{email.to[0].address}</p>
            <p className="no-translate">{formatDate(email.createdAt, DateFormat.DATE_TIME_SHORT)}</p>
        </div>
    );
};
